import React, { forwardRef, useContext, useImperativeHandle, useMemo, useRef } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { IconCheckBold, IconCloseBold } from '../icon';
import { ContextLayout } from '../context-provider';
import { StepsContext } from './index';
var Step = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
      description = props.description,
      icon = props.icon;

  var _useContext = useContext(StepsContext),
      iconType = _useContext.iconType,
      current = _useContext.current,
      direction = _useContext.direction,
      _useContext$index = _useContext.index,
      index = _useContext$index === void 0 ? 0 : _useContext$index,
      contextStatus = _useContext.status,
      changeIndex = _useContext.changeIndex;

  var status = props.status || contextStatus;
  var domRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });
  var currentStatus = useMemo(function () {
    if (status) return status;

    if (current < index) {
      return 'wait';
    } else if (current === index) {
      return 'process';
    }

    return 'finish';
  }, [status, index, current]);

  function renderNumIcon(prefixCls) {
    var content;

    if (currentStatus === 'finish') {
      content = /*#__PURE__*/React.createElement(IconCheckBold, null);
    } else if (currentStatus === 'error') {
      content = /*#__PURE__*/React.createElement(IconCloseBold, null);
    }

    return content || /*#__PURE__*/React.createElement("span", {
      className: cls(prefixCls + "-steps-item-icon-num")
    }, index + 1);
  }

  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("div", {
      ref: domRef,
      className: cls(prefixCls + "-steps-item", currentStatus, direction, iconType),
      onClick: function onClick() {
        return changeIndex(index);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: cls(prefixCls + "-steps-item-tail", currentStatus + "-tail-color-with-config")
    }), icon ? /*#__PURE__*/React.createElement("div", {
      className: cls(prefixCls + "-steps-item-custom-icon", currentStatus + "-custom-icon-bg-color-with-config")
    }, icon) : /*#__PURE__*/React.createElement("div", {
      className: cls(prefixCls + "-steps-item-icon", currentStatus + "-bg-color-with-config")
    }, iconType === 'number' ? renderNumIcon(prefixCls) : /*#__PURE__*/React.createElement("span", {
      className: cls(prefixCls + "-steps-item-icon-dot")
    })), title || description ? /*#__PURE__*/React.createElement("div", {
      className: cls(prefixCls + "-steps-item-content")
    }, title ? /*#__PURE__*/React.createElement("div", {
      className: cls(prefixCls + "-steps-item-title", currentStatus + "-title-color-with-config")
    }, title) : null, description ? /*#__PURE__*/React.createElement("div", {
      className: cls(prefixCls + "-steps-item-description")
    }, description) : null) : null);
  });
});
export default Step;